export default __webpack_public_path__ + "static/media/subLogo.276dd3e1.svg";